import { injectIntl } from 'react-intl';
import React, { useState, useEffect, useContext } from 'react';

import myContext from '@/utils/createContext';

function ThemePc(props) {
	const { intl } = props;
	const { formatMessage } = intl;
	const data = useContext(myContext);
	const {
		logoUrl,
		webDomain,
		themeColor
	} = data || {};

	return (
		<div className="h5pc-cashier-logo-container vh5pc-cashier-logo-container">
			<img className="vh5pc-cashier-logo-container-image" src={logoUrl} alt={webDomain} />
		</div>
	)
}

export default injectIntl(ThemePc);